<h2>Payments</h2>

<lib-titled-card>
  <h3>Payment History</h3>
  <app-payment-list [list$]="payments$"> </app-payment-list>
</lib-titled-card>
